import { render, staticRenderFns } from "./SchoolManagementForAdmin.vue?vue&type=template&id=056bfd1d"
import script from "./SchoolManagementForAdmin.vue?vue&type=script&lang=js"
export * from "./SchoolManagementForAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports